import { ROLE_REPORTING_ADMIN } from '~/consts/roles';

import isProd from './isProd';

const ENGINEERING_LEADERSHIP_EMAILS: ReadonlyArray<string> = [
  'fabien.ruffin@luxuryescapes.com',
  'joshua.cullen@luxuryescapes.com',
  'joshua.paling@luxuryescapes.com',
  'konstantin.bartchenkov@luxuryescapes.com',
];

const PRODUCT_EMAILS: ReadonlyArray<string> = [
  'alice.shang@luxuryescapes.com',
  'amanda.tansi@luxuryescapes.com',
  'braydn.evans@luxuryescapes.com',
  'chiamaka.ibeme@luxuryescapes.com',
  'david.kokolich@luxuryescapes.com',
  'gus.stone-heesh@luxuryescapes.com',
  'hunter.li@luxuryescapes.com',
  'isaac.ho@luxuryescapes.com',
  'jacob.meyer@luxuryescapes.com',
  'jake.gerstel@luxuryescapes.com',
  'jake.pajer@luxuryescapes.com',
  'james.ball@luxuryescapes.com',
  'james.nevett@luxuryescapes.com',
  'luke.pipolo@luxuryescapes.com',
  'min.pangastur@luxuryescapes.com',
  'nick.griffith@luxuryescapes.com',
  'nicholas.lavis@luxuryescapes.com',
  'nish.shrestha@luxuryescapes.com',
  'oliver.banks@luxuryescapes.com',
  'oscar.prien@luxuryescapes.com',
  'renan.murta@luxuryescapes.com',
  'samuel.drown@luxuryescapes.com',
  'sean.novis@luxuryescapes.com',
  'sharon.maprasert@luxuryescapes.com',
  'shay.hamama@luxuryescapes.com',
  'tarun.verma@luxuryescapes.com',
  'tina.wang@luxuryescapes.com',
  'tom.strathern@luxuryescapes.com',
  'vivi.mi@luxuryescapes.com',
  'william.ritossa@luxuryescapes.com',
];

const PILOT_EMAILS: ReadonlyArray<string> = [
  'belinda.zelesco@luxuryescapes.com',
  'christie.fekete@luxuryescapes.com',
  'claire.mouchoux@luxuryescapes.com',
  'colin.pringle-wood@luxuryescapes.com',
  'edan.lattimore@luxuryescapes.com',
  'eliza.welsh@luxuryescapes.com',
  'glen.kilpatrick@luxuryescapes.com',
  'harry.obrien@luxuryescapes.com',
  'james.hardy@luxuryescapes.com',
  'kieran.perkins@luxuryescapes.com',
  'koren.sela@luxuryescapes.com',
  'laura.ofarrell@luxuryescapes.com',
  'lloyd.hesson@luxuryescapes.com',
  'louise.hughes@luxuryescapes.com',
  'michael.condello@luxuryescapes.com',
  'nathan.contin@luxuryescapes.com',
  'neil.ellis@luxuryescapes.com',
  'raph.gong@luxuryescapes.com',
  'sidonie.moore@luxuryescapes.com',
  'tom.mcmenemie@luxuryescapes.com',
  'travis.hill@luxuryescapes.com',
  'youkee.fan@luxuryescapes.com',
];

export const LENS_TEMPORARY_ALLOWED_EMAILS: ReadonlyArray<string> = [
  ...ENGINEERING_LEADERSHIP_EMAILS,
  ...PRODUCT_EMAILS,
  ...PILOT_EMAILS,
];

const temporarilyAllowedEmails = new Set(LENS_TEMPORARY_ALLOWED_EMAILS.map((email) => email.toLowerCase()));

type LensUser = { roles?: Array<string>; email?: string | null };

export function canAccessLeLens(user: LensUser | null | undefined): boolean {
  if (!user) {
    return false;
  }

  if (!isProd()) {
    return true;
  }

  if (user.roles?.includes(ROLE_REPORTING_ADMIN)) {
    return true;
  }

  return Boolean(user.email && temporarilyAllowedEmails.has(user.email.trim().toLowerCase()));
}
